import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAdmin, RequireAuth, RequireGuest } from './guards';
import { RouteError } from './RouteError';

export const router = createBrowserRouter([
  {
    lazy: () => import('@/app/layouts/PublicLayout'),
    children: [
      { index: true, lazy: () => import('@/pages/public/LandingPage') },
      { path: 'about', lazy: () => import('@/pages/public/AboutPage'), handle: { title: 'О сервисе' } },
      {
        path: 'privacy',
        lazy: () => import('@/pages/public/PrivacyPage'),
        handle: { title: 'Политика обработки данных' },
      },
      {
        path: 'terms',
        lazy: () => import('@/pages/public/TermsPage'),
        handle: { title: 'Пользовательское соглашение' },
      },
      {
        path: 'accessibility',
        lazy: () => import('@/pages/public/AccessibilityPage'),
        handle: { title: 'Заявление о доступности' },
      },
    ],
  },
  {
    element: <RequireGuest />,
    children: [
      {
        lazy: () => import('@/app/layouts/AuthLayout'),
        children: [
          { path: 'login', lazy: () => import('@/pages/public/LoginPage'), handle: { title: 'Вход' } },
          { path: 'register', lazy: () => import('@/pages/public/RegisterPage'), handle: { title: 'Регистрация' } },
        ],
      },
    ],
  },
  {
    path: 'app',
    element: <RequireAuth />,
    children: [
      {
        lazy: () => import('@/app/layouts/AppLayout'),
        children: [
          { index: true, lazy: () => import('@/pages/app/HomePage'), handle: { title: 'Главная' } },
          { path: 'sources/:id', lazy: () => import('@/pages/app/KnowledgeSourcePage'), handle: { title: 'Источник ответа' } },
          {
            path: 'chat',
            lazy: () => import('@/pages/app/ChatPage'),
            handle: { title: 'Чат с навигатором', headerTitle: true },
          },
          {
            path: 'recommendations',
            lazy: () => import('@/pages/app/RecommendationsPage'),
            handle: { title: 'Рекомендации' },
          },
          {
            path: 'recommendations/:id',
            lazy: () => import('@/pages/app/RecommendationDetailPage'),
            handle: { title: 'Мера поддержки' },
          },
          {
            path: 'documents',
            lazy: () => import('@/pages/app/DocumentsPage'),
            handle: { title: 'Переводчик документов' },
          },
          {
            path: 'documents/result',
            lazy: () => import('@/pages/app/DocumentResultPage'),
            handle: { title: 'Результат обработки' },
          },
          {
            path: 'places',
            lazy: () => import('@/pages/app/PlacesPage'),
            handle: { title: 'Карта организаций', headerTitle: true },
          },
          {
            path: 'places/:id',
            lazy: () => import('@/pages/app/PlaceDetailPage'),
            handle: { title: 'Карточка организации' },
          },
          { path: 'profile', lazy: () => import('@/pages/app/ProfilePage'), handle: { title: 'Профиль семьи' } },
          { path: 'settings', lazy: () => import('@/pages/app/SettingsPage'), handle: { title: 'Настройки' } },
          { path: 'help', lazy: () => import('@/pages/app/HelpPage'), handle: { title: 'Справка' } },
        ],
      },
    ],
  },
  {
    path: 'admin/login',
    lazy: () => import('@/app/layouts/AuthLayout'),
    children: [{ index: true, lazy: () => import('@/pages/public/AdminLoginPage'), handle: { title: 'Вход администратора' } }],
  },
  {
    path: 'admin',
    element: <RequireAdmin />,
    children: [
      {
        lazy: () => import('@/app/layouts/AdminLayout'),
        children: [
          { index: true, element: <Navigate to="/admin/stats" replace /> },
          {
            path: 'knowledge',
            lazy: () => import('@/pages/admin/KbListPage'),
            handle: { title: 'База знаний' },
          },
          {
            path: 'knowledge/upload',
            lazy: () => import('@/pages/admin/KbUploadPage'),
            handle: { title: 'Добавить материал' },
          },
          {
            path: 'knowledge/:id',
            lazy: () => import('@/pages/admin/KbDetailPage'),
            handle: { title: 'Материал базы знаний' },
          },
          { path: 'stats', lazy: () => import('@/pages/admin/StatsPage'), handle: { title: 'Статистика' } },
          { path: 'partners', lazy: () => import('@/pages/admin/PartnersPage'), handle: { title: 'Партнёры' } },
          { path: 'support-measures', lazy: () => import('@/pages/admin/SupportMeasuresPage'), handle: { title: 'Меры поддержки' } },
          { path: 'support-measures/new', lazy: () => import('@/pages/admin/SupportMeasurePage'), handle: { title: 'Новая мера поддержки' } },
          { path: 'support-measures/:id', lazy: () => import('@/pages/admin/SupportMeasurePage'), handle: { title: 'Мера поддержки' } },
          { path: 'support-measures/:id/edit', lazy: () => import('@/pages/admin/SupportMeasurePage'), handle: { title: 'Редактирование меры' } },
          {
            path: 'settings',
            lazy: () => import('@/pages/admin/AdminSettingsPage'),
            handle: { title: 'Настройки администратора' },
          },
        ],
      },
    ],
  },
  { path: '*', lazy: () => import('@/pages/NotFoundPage') },
].map(route => ({ ...route, errorElement: <RouteError /> })));
